export default __webpack_public_path__ + "static/Child-Learning-Screens-x2-d038598e4f7b792e08ba59963fbcef0b.png";